export type AppearancePreference = 'system' | 'light' | 'dark'
export type ResolvedAppearance = 'light' | 'dark'

const HINT_KEY = 'pexify_appearance'

function validPreference(value: string | null | undefined): AppearancePreference | null {
  return value === 'system' || value === 'light' || value === 'dark' ? value : null
}

export function resolveAppearance(preference: AppearancePreference, systemDark: boolean): ResolvedAppearance {
  return preference === 'system' ? (systemDark ? 'dark' : 'light') : preference
}

export function readAppearanceHint(): AppearancePreference {
  if (typeof document === 'undefined') return 'system'
  try {
    const cookie = document.cookie.split('; ').find((entry) => entry.startsWith(`${HINT_KEY}=`))
    if (cookie) {
      const value = validPreference(decodeURIComponent(cookie.slice(HINT_KEY.length + 1)))
      if (value) return value
    }
    return validPreference(localStorage.getItem(HINT_KEY)) ?? 'system'
  } catch {
    return 'system'
  }
}

export function writeAppearanceHint(preference: AppearancePreference): void {
  if (typeof window === 'undefined') return
  try {
    if (window.location.hostname === 'pexify.net' || window.location.hostname.endsWith('.pexify.net')) {
      const secure = window.location.protocol === 'https:' ? '; Secure' : ''
      document.cookie = `${HINT_KEY}=${preference}; Path=/; Domain=.pexify.net; SameSite=Lax; Max-Age=31536000${secure}`
    } else {
      localStorage.setItem(HINT_KEY, preference)
    }
  } catch {
    // Appearance is cosmetic; storage denial must not block the app.
  }
}
